<template>
  <div>
    <el-row>
      <el-col style="margin-top: 20px">
        <el-button size="medium" @click="openAdd">新增</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table stripe border style="margin-top: 20px" :data="tableData">
          <el-table-column type="index" label="序号" width="80"></el-table-column>
          <el-table-column prop="NAME" label="菜品名称"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button @click="deleteMatch(scope.row)" type="text">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <!-- 新增/修改模态框 -->
    <el-dialog title="编辑" center :visible.sync="editFormVisible" width="380px">
      <el-form :model="editForm" ref="editForm" size="small" :inline="true" :label-width="formLableWidth">
        <el-form-item label="菜品：">
          <el-select v-model="editForm.DISHES" style="width: 93%" filterable>
            <el-option v-for="(item, index) in dishesLists" :key="index" :label="item.NAME" :value="item.DP_CODE">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="editFormVisible = false">取 消</el-button>
        <el-button size="small" @click="submitAdd()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  queryAllDishesFun, queryMatchDishesFun, addDishesFun, delDishesFun,
} from 'api/packageManage';

export default {
  data() {
    return {
      tableData: [],
      editForm: {},
      editFormVisible: false,
      dishesLists: [],
      formLableWidth: '100px',
    };
  },
  methods: {
    queryAllDishes() {
      const params = {};
      queryAllDishesFun(params).then((result) => {
        if (result.length !== 0) {
          this.dishesLists = result;
        } else {
          this.dishesLists = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    queryData() {
      const params = {
        MEAL_PRODUCT_CODE: sessionStorage.getItem('menuCode'),
      };
      queryMatchDishesFun(params).then((result) => {
        if (result.length !== 0) {
          this.tableData = result;
        } else {
          this.tableData = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    openAdd() {
      this.editFormVisible = true;
      this.queryAllDishes();
    },
    submitAdd() {
      if (!this.editForm.DISHES) {
        this.$message.show({ text: '请选择菜品', type: 'warning' });
        return false;
      }
      const params = {
        MEAL_PRODUCT_CODE: sessionStorage.getItem('menuCode'),
        MADE_UP_PRODUCT_CODE: this.editForm.DISHES,
      };
      addDishesFun(params).then((result) => {
        this.$message.show({ text: '新增成功', type: 'success' });
        this.editForm = {};
        this.queryData();
        this.editFormVisible = false;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    deleteMatch(row) {
      this.$confirm('确认删除该菜品吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const params = {
          ID: row.ID,
        };
        delDishesFun(params).then((res) => {
          this.queryData();
          this.$message.show({ text: '操作成功', type: 'success' });
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作',
        });
      });
    },
  },
  created() {
    this.queryData();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/productionProcessing/matchDishes.vue